// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1XA3F","icon":"SortAdornment_icon__As43t","up":"SortAdornment_up__XUj6F","down":"SortAdornment_down__1dc9U","active":"SortAdornment_active__1uzWH"};